import { Sun, CloudSun, Cloud, CloudRain, Wind, Waves } from 'lucide-react';

export const STATE_COLORS = { verde: '#16854A', naranja: '#C4620C', rojo: '#C82E28', gris: '#768082' };
export const NEUTRAL_COLOR = '#7CCBC6';
export const PILL_BORDER = '#2A8F8A';
export const TEMP_TEXT = '#0F4C4A';

export const COND_ICONS = { sol: Sun, sol_nubes: CloudSun, nublado: Cloud, lluvia: CloudRain, viento: Wind, mar_malo: Waves };

export const COND_LABELS = {
  es: {
    states: { verde: 'bien', naranja: 'regular', rojo: 'mejor otra zona', gris: 'sin dato reciente' },
    icons: { sol: 'sol', sol_nubes: 'sol y nubes', nublado: 'nublado', lluvia: 'lluvia', viento: 'viento', mar_malo: 'mar malo' },
    updated: 'Actualizado a las', webcam: 'Webcam', degrees: 'grados',
  },
  en: {
    states: { verde: 'good', naranja: 'fair', rojo: 'better elsewhere', gris: 'no recent data' },
    icons: { sol: 'sunny', sol_nubes: 'sun and clouds', nublado: 'cloudy', lluvia: 'rain', viento: 'windy', mar_malo: 'rough sea' },
    updated: 'Updated at', webcam: 'Webcam', degrees: 'degrees',
  },
  de: {
    states: { verde: 'gut', naranja: 'mäßig', rojo: 'anderswo besser', gris: 'keine aktuellen Daten' },
    icons: { sol: 'sonnig', sol_nubes: 'Sonne und Wolken', nublado: 'bewölkt', lluvia: 'Regen', viento: 'windig', mar_malo: 'raue See' },
    updated: 'Aktualisiert um', webcam: 'Webcam', degrees: 'Grad',
  },
};

const canaryFmt = new Intl.DateTimeFormat('es-ES', { timeZone: 'Atlantic/Canary', hour: '2-digit', minute: '2-digit', hour12: false });
const canaryDay = new Intl.DateTimeFormat('en-CA', { timeZone: 'Atlantic/Canary', year: 'numeric', month: '2-digit', day: '2-digit' });

export const roundHalfUp = (n) => Math.floor(n + 0.5);
export const canaryTime = (iso) => canaryFmt.format(new Date(iso));

// Freshness is computed at paint time with the device clock (server returns the raw record).
export function conditionView(condition, now = new Date()) {
  if (!condition?.actualizado_en) return { state: null, showPill: false, dimmed: false };
  const at = new Date(condition.actualizado_en);
  if (Number.isNaN(at.getTime())) return { state: null, showPill: false, dimmed: false };
  const ageH = (now - at) / 36e5;
  const sameDay = canaryDay.format(at) === canaryDay.format(now);
  if (ageH > 6 || !sameDay) return { state: null, showPill: false, dimmed: false, stale: true };
  const stale = ageH > 3;
  return {
    state: stale ? 'gris' : condition.estado,
    color: STATE_COLORS[stale ? 'gris' : condition.estado],
    showPill: !condition.sin_pastilla,
    dimmed: stale,
    temp: roundHalfUp(condition.temp_c),
    icon: condition.icono,
    time: canaryTime(condition.actualizado_en),
    posicion: condition.posicion || null,
  };
}

export function conditionAria(camLabel, cond, view, language) {
  const L = COND_LABELS[language] || COND_LABELS.es;
  if (!view?.state) return `${L.webcam} ${camLabel}`;
  const short = cond?.texto_corto?.[language] || cond?.texto_corto?.es || L.icons[view.icon] || '';
  const stateTxt = L.states[view.state];
  return `${L.webcam} ${camLabel}: ${stateTxt}. ${view.temp} ${L.degrees}${short ? `, ${short}` : ''}. ${L.updated} ${view.time}`;
}

export const LEGEND = {
  es: [['verde', 'bien'], ['naranja', 'regular'], ['rojo', 'mejor otra zona'], ['gris', 'sin dato reciente']],
  en: [['verde', 'good'], ['naranja', 'fair'], ['rojo', 'better elsewhere'], ['gris', 'no recent data']],
  de: [['verde', 'gut'], ['naranja', 'mäßig'], ['rojo', 'anderswo besser'], ['gris', 'keine akt. Daten']],
};
